import { Injectable } from '@angular/core';
import { OVERSEAS_EDITION_DATE_FORMAT_V2, OVERSEAS_EDITION_TIME_FORMAT_V2 } from '@root/config';
import _ from 'lodash';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Subject } from 'rxjs';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  private readonly dateFormatKey = 'hostex-i18n-dateformat';
  private readonly timeFormatKey = 'hostex-i18n-timeformat';

  private dateFormat: number = 0;

  /** 时间的格式化 */
  private timeFormat: number = 0;

  dateFormatChange$ = new Subject();
  timeFormatChange$ = new Subject();

  constructor(
    private storeService: StoreService
  ) { }

  /**
   * @public
   * @params f: Array<string> || string
   * @example
   * ///   format(['YMD', 'hms']) 根据系统设置格式时间 Y年 M月 D日  h时 m分 s秒
   * ///   format(['YMD']) 只显示日期，不显示时间
   * ///   format(['MD']) 只展示月和日
   * ///   format(['YM']) 只展示年和月
   * ///   format(['YM', 'hm']) 展示年月与时分
   *
   * ///   format('YYYY-MM-DD')   自定义格式时间
  */

  format(value, f): string {

    const mo = moment(value);
    mo.locale('en')

    if (_.isArray(f) || !f) {
      const format = this.getMomentFormat(f);
      return mo.format(format);
    } else {
      return mo.format(f);
    }
  }

  setDateFormat(format: number) {
    this.dateFormat = format;
    this.setDateFormatToLocal(format);
    this.dateFormatChange$.next();
  }

  setTimeFormat(format: number) {
    this.timeFormat = format;
    this.setTimeFormatToLocal(format);
    this.timeFormatChange$.next();
  }

  getTimeFormat(): number {
    if (_.isNil(this.timeFormat)) {
      return this.getTimeFormatFromLocal();
    }
    return this.timeFormat;
    // return this.timeFormat || this.getTimeFormatFromLocal();
  }

  getDateFormat(): number {
    if (_.isNil(this.dateFormat)) {
      this.getDateFormatFromLocal();
    }
    return this.dateFormat;
    // return this.dateFormat || this.getDateFormatFromLocal();
  }

  private getDateFormatFromLocal(): number {
    return +this.storeService.get(this.dateFormatKey, 2);
  }
  private getTimeFormatFromLocal(): number {
    return +this.storeService.get(this.timeFormatKey, 2);
  }

  private setDateFormatToLocal(format: number) {
    this.storeService.set(this.dateFormatKey, format, 2);
  }
  private setTimeFormatToLocal(format: number) {
    this.storeService.set(this.timeFormatKey, format, 2);
  }

  /**
   * @private
   * 获取moment库需要的格式化字符串
   * EXAMPLE: YYYY-MM-DD
   */
  private getMomentFormat(formats: Array<string> | null): string {

    if (_.isEmpty(formats)) {
      return `${this.getDateFormatByField('YMD')} ${this.getTimeFormatByField('hms')}`;
    }

    const [df, tf] = formats;
    if (!tf) {
      return this.getDateFormatByField(df);
    }
    if (!df) {
      return this.getTimeFormatByField(tf);
    }

    return `${this.getDateFormatByField(df)} ${this.getTimeFormatByField(tf)}`
  }

  /**
   * @public
   * 获取内部管道需要的格式化时间字符串
   * 与moment的字符串略有不同，Y -> y, D -> d
   * 一般为ng-zorro-antd时间组件的显示需要
   */
  getAngularFormat(formats: Array<string> | null) {
    return this.getMomentFormat(formats)
      .replace(/Y/g, 'y')
      .replace(/D/g, 'd');
  }

  getDateFormatByField(field: string) {
    // const value = this.international.getDateFormat() || 0;
    const value = this.getDateFormat() || 0;
    const item = _.find(OVERSEAS_EDITION_DATE_FORMAT_V2, { value });

    return item && item[_.toLower(field)];
  }

  getTimeFormatByField(field: string) {
    // const value = this.international.getTimeFormat() || 0;
    const value = this.getTimeFormat() || 0;
    const item = _.find(OVERSEAS_EDITION_TIME_FORMAT_V2, { value });
    return item && item[_.toLower(field)]
  }

  clearLocalKeys() {
    this.storeService.remove(this.dateFormatKey, 2);
    this.storeService.remove(this.timeFormatKey, 2);
  }
}
